import type { InspirationAlsoReadBlockDTO } from 'autogen/swagger/all';
import { ArticleBlock } from 'autogen/translation-keys/trans-root-website';
import styled from 'styled-components';
import {
    FontLineHeightNormal,
    FontFontFamilySecondary,
    FontSize14,
    FontWeightSemiBold,
    FontSize16,
    ColorNeutralDarkGrey
} from 'autogen/design-tokens/tokens';
import { useTranslation } from 'react-i18next';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';

export type InspirationAlsoReadPlaceholderProps = {
    model: InspirationAlsoReadBlockDTO;
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const ArticleContainer = styled.div`
    display: flex;
    flex-wrap: no-wrap;
    padding-bottom: 10px;
    margin: 0 30px;
    border-bottom: solid 1px #b09e98;
`;

const PictureLink = styled.a`
    margin-right: 42px;

    & img {
        object-fit: cover;
        vertical-align: middle;
        max-width: 4.2857142857rem;
        min-width: 4.2857142857rem;
    }
`;

const Body = styled.div<{ displayRow: boolean }>`
    display: flex;
    flex-direction: ${(props) => (props.displayRow ? 'row' : 'column')};
    justify-content: center;
    align-items: ${(props) => (props.displayRow ? 'center' : 'start')};
`;

const Title = styled.a`
    font-family: ${FontFontFamilySecondary};
    line-height: ${FontLineHeightNormal};
    font-size: ${FontSize16};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${ColorNeutralDarkGrey};
    flex: 0 1 auto;
    max-width: 100%;
    word-break: break-word;
    word-wrap: break-word;
`;

const ReadMore = styled.a<{ marginRight: number; canShrink: boolean }>`
    font-size: ${FontSize14};
    font-weight: ${FontWeightSemiBold};
    color: #000000;
    text-decoration: underline;
    margin-right: ${(props) => props.marginRight}px;
    flex: ${(props) => (props.canShrink ? 'initial' : '1 0 auto')};
`;

export default function SingleArticleBlock({
    model,
    withPicture = false
}: InspirationAlsoReadPlaceholderProps & { withPicture?: boolean }) {
    const { t } = useTranslation();

    return (
        <Container>
            {model.articles.map((article) => (
                <ArticleContainer key={article.id}>
                    {withPicture && (
                        <PictureLink href={article.url}>
                            <PictureDeprecated {...article.image_1x1} />
                        </PictureLink>
                    )}
                    <Body displayRow={!withPicture}>
                        <ReadMore canShrink={withPicture} marginRight={!withPicture ? 30 : 0} href={article.url}>
                            {t(ArticleBlock.ReadAlso)}
                        </ReadMore>
                        <Title href={article.url}>{article.title}</Title>
                    </Body>
                </ArticleContainer>
            ))}
        </Container>
    );
}
